import { CloverAccount, SquareAccount } from '../admin/store';

export class SquareAccountViewModel {
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public storeId: number = 0;
}

export class SquareAccountListViewModel extends SquareAccountViewModel {
    public accounts: SquareAccount[] = [];
}

export class SquareAccountAddOrUpdateViewModel extends SquareAccountViewModel {
    public account: SquareAccount = {};
    public applicationId: string = '';
    public accessToken: string = '';
}


export class CloverAddOrUpdateViewModel extends SquareAccountViewModel {
    public account: CloverAccount = {};
    public paymentBaseUrl?: string;
    public merchantId?: string;
    public accessToken?: string;
    public publicToken?: string;
    public privateToken?: string;
    public environment?: string;
}
